import type { UrlForwardParamsConfig } from '@/config/shared/url-context';

import { buildDenylistSet, isDeniedKey, normalizeParamKey } from './utils';

/**
 * Decide quais params (não gerenciados) propagar em links.
 * Não gera nem persiste — só filtra.
 */
export class ForwardParamResolver {
  resolve(input: {
    queryParams: Record<string, string>;
    managedValues: Record<string, string>;
    config: UrlForwardParamsConfig | undefined;
  }): Record<string, string> {
    const { queryParams, managedValues, config } = input;
    if (!config || config.enabled === false) return {};

    const denylist = buildDenylistSet(
      config.denylist,
      config.mergeDefaultDenylist
    );
    const mode = config.mode ?? 'all_except';
    const allowlist = new Set(
      (config.allowlist ?? []).map(normalizeParamKey).filter(Boolean)
    );

    const result: Record<string, string> = {};

    for (const [key, value] of Object.entries(queryParams)) {
      if (!value) continue;
      if (isDeniedKey(key, denylist)) continue;
      if (key in managedValues) continue; // managed tem prioridade
      if (mode === 'allowlist' && !allowlist.has(normalizeParamKey(key))) {
        continue;
      }
      result[key] = value;
    }

    return result;
  }
}
